var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5729_3294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5729_3294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50001 12.834C3.17918 12.834 2.90452 12.7197 2.67605 12.4913C2.44758 12.2628 2.33334 11.9882 2.33334 11.6673V5.83398C2.33334 5.51315 2.44758 5.2385 2.67605 5.01003C2.90452 4.78155 3.17918 4.66732 3.50001 4.66732H4.08334V3.50065C4.08334 2.69371 4.36772 2.00586 4.93647 1.43711C5.50522 0.868359 6.19307 0.583984 7.00001 0.583984C7.80695 0.583984 8.4948 0.868359 9.06355 1.43711C9.6323 2.00586 9.91668 2.69371 9.91668 3.50065V4.66732H10.5C10.8208 4.66732 11.0955 4.78155 11.324 5.01003C11.5524 5.2385 11.6667 5.51315 11.6667 5.83398V11.6673C11.6667 11.9882 11.5524 12.2628 11.324 12.4913C11.0955 12.7197 10.8208 12.834 10.5 12.834H3.50001ZM3.50001 11.6673H10.5V5.83398H3.50001V11.6673ZM7.00001 9.91732C7.32084 9.91732 7.5955 9.80308 7.82397 9.57461C8.05244 9.34614 8.16668 9.07148 8.16668 8.75065C8.16668 8.42982 8.05244 8.15517 7.82397 7.92669C7.5955 7.69822 7.32084 7.58398 7.00001 7.58398C6.67918 7.58398 6.40452 7.69822 6.17605 7.92669C5.94758 8.15517 5.83334 8.42982 5.83334 8.75065C5.83334 9.07148 5.94758 9.34614 6.17605 9.57461C6.40452 9.80308 6.67918 9.91732 7.00001 9.91732ZM5.25001 4.66732H8.75001V3.50065C8.75001 3.01454 8.57987 2.60135 8.23959 2.26107C7.89932 1.92079 7.48612 1.75065 7.00001 1.75065C6.5139 1.75065 6.1007 1.92079 5.76043 2.26107C5.42015 2.60135 5.25001 3.01454 5.25001 3.50065V4.66732Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b4c0bbeadebab343a068cd1730616c73.svg";
export { ForwardRef as ReactComponent };